import React, { useEffect, useState } from "react";
import FooterLinks from "./FooterLinks.js";
import FooterSocial from "./FooterSocial.js";

interface FooterSectionProps {
  className?: string;
}

const FooterSection: React.FC<FooterSectionProps> = ({ className }) => {
  const [year, setYear] = useState<string>("");

  useEffect(() => {
    setYear(new Date().getFullYear().toString());
  }, []);

  return (
    <footer className={`bg-nearblack-500 py-12 ${className || ""}`}>
      <div className="px-4 sm:px-8 lg:px-24">
        <div className="content-container">
          <div className="flex flex-col gap-8 lg:flex-row lg:gap-16">
            <div className="flex-1">
              <FooterLinks />
            </div>
            <div className="lg:w-64">
              <FooterSocial />
            </div>
          </div>

          <div className="mt-8 border-t border-gray-700 pt-8">
            <a
              href="#"
              className="text-sm text-gray-400 hover:text-meteoyellow-500"
            >
              ©{year} MétéoMédiocre Corp (une filiale imaginaire de Pelmorex)
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
